<form class="popupForm" style="min-height: 200px;" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: 200px;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      Update client points
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke"
                        style=""
    >
      <mat-form-field appearance="outline" color="accent" style="width: 100%">
        <mat-label>Points</mat-label>
        <input matInput id="mkdir-name-input" type="text"
               (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" (keydown.enter)="handleSubmit($event)"
               cdkFocusInitial formControlName="pointsInput">
      </mat-form-field>
      <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
           *ngIf="validationResult && !validationResult.isValid && validationResult.message">
        <mat-icon color="warn">error</mat-icon><span>{{ validationResult.message}}</span>
      </div>
    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button type="button" mat-button class="cancel widerButton font16" (click)="onNoClick()">
        Cancel
      </button>
      <button type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
        Update
      </button>
    </div>
  </div>
</form>
